import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

function OrdersComponent(props) {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const [ORDERS, setORDERS] = useState();

  useEffect(() => {
    props.top_loading(50);

    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
      try {
        props.top_loading(80);
        const response = await axiosPrivate.get(
          `orders/ordersbyuserid/${props.auth.creds?.userid}`,
          { credentials: "include" },
          {
            signal: controller.signal,
          }
        );
        setORDERS(response.data);
        props.top_loading(100);

        isMounted && props.fetchingorders(response.data);
      } catch (err) {
        console.error(err);
        props.logoutUser();
      }
    };

    getUsers();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);



  const myorders = ORDERS;

  return (
    <div className="container mx-auto">

      <h1 className="font-bold textt-2xl p-6">My orders</h1>
      <div>
        <div className="flex gap-24  border p-2 ">
          <div className="hidden lg:block w-[5%]  text-center font-bold border-r-0 ">S.No</div>
          <div className="w-[300px] lg:text-center font-bold border-r-0 ">Order Id</div>
          <div className="hidden lg:block w-[300px] text-center font-bold border-r-0 ">Email</div>
          <div className="w-[5%] lg:text-center font-bold border-r-0 ">Amount</div>

        </div>
      </div>
      <div>
        {myorders?.map((x, index) => (
          <Link className="flex gap-24 border p-2 hover:bg-teal-300" key={x._id} to={`/order/${x._id}`}>


            <div className=" hidden lg:block w-[5%] border-r-0   text-center">
              {index + 1}
            </div>
            <div className="w-[200px] lg:w-[300px] border-r-0  text-center">
              {x._id}
            </div>
            <div className="hidden lg:block w-[300px] border-r-0   text-center">
              {x.email}
            </div>
            <div className="w-[5%] border-r-0    text-center">
              ₹{x.amount / 100}
            </div>


          </Link>
        ))}

      </div>

    </div >
  );
}

export default OrdersComponent;
